import { t } from '../../../shared/config/translations'

const STAR_ICON = `
    <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"/>
    </svg>
`

export function releaseRatingStarsTemplate(rating: number | null): string {
	const clearButton = `
        <button
            type="button"
            class="release-rating-clear"
            data-release-rating-value="0"
            role="radio"
            aria-checked="${rating === null}"
            aria-label="${t('release.removeRating')}"
        ></button>
    `
	const stars = Array.from({ length: 5 }, (_, index) => index + 1)
		.map(
			(value) => `
                <button
                    type="button"
                    class="release-rating-star${rating !== null && value <= rating ? ' is-filled' : ''}"
                    data-release-rating-value="${value}"
                    role="radio"
                    aria-checked="${rating === value}"
                    aria-label="${t('release.rateOutOfFive').replace('%{rating}', String(value))}"
                >${STAR_ICON}</button>
            `,
		)
		.join('')
	return clearButton + stars
}

export function releaseRatingEditorTemplate(rating: number | null): string {
	return `
        <div id="release-rating-editor" class="release-rating-editor" hidden>
            <div
                class="release-rating-stars"
                role="radiogroup"
                aria-label="${t('release.yourRating')}"
            >${releaseRatingStarsTemplate(rating)}</div>
        </div>
    `
}

export function releaseHeaderRatingTemplate(
	rating: number | null,
	withSeparator: boolean,
): string {
	if (rating === null) return ''
	const stars = Array.from({ length: rating }, () => STAR_ICON).join('')
	return `${withSeparator ? '<span aria-hidden="true">·</span>' : ''}<span class="release-header-rating-stars" aria-label="${t('release.rateOutOfFive').replace('%{rating}', String(rating))}">${stars}</span>`
}
